import type { MetaInfo } from "vue-meta";
import { setSizeProductDetail } from "~/modules/catalog/category/helpers";

export const getMetaInfo = (page: any, isNoIndex: boolean = false): MetaInfo => {
  if (!page) {
    return null;
  }

  const seoTags: MetaInfo = {
    meta: [],
  };

  if (page?.meta_title || page?.title || page?.name) {
    seoTags.title = page?.meta_title || page?.title || page?.name;
    seoTags.meta.push({
      vmid: "og:title",
      property: "og:title",
      content: seoTags.title,
    });

    seoTags.meta.push({
      vmid: "twitter:title",
      property: "twitter:title",
      content: seoTags.title,
    });
  }

  if (page?.meta_description) {
    seoTags.meta.push({
      vmid: "og:description",
      hid: "og:description",
      property: "og:description",
      content: page.meta_description,
    });

    seoTags.meta.push({
      vmid: "description",
      hid: "description",
      name: "description",
      content: page.meta_description,
    });

    seoTags.meta.push({
      vmid: "twitter:description",
      hid: "twitter:description",
      property: "twitter:description",
      content: page.meta_description,
    });
  }

  if (page?.meta_keyword || page?.meta_keywords) {
    seoTags.meta.push({
      hid: "keywords",
      property: "keywords",
      content: page?.meta_keyword || page?.meta_keywords,
    });
  }

  if (page?.image || page?.image_map || page?.simi_category_thumbnail || page?.content_heading) {
    const imageThum = page.image || setSizeProductDetail(page.image_map) || page.simi_category_thumbnail || page.content_heading;
    seoTags.meta.push({
      vmid: "og:image",
      property: "og:image",
      content: imageThum,
    });
  }

  if (isNoIndex) {
    seoTags.meta.push({
      vmid: "robots",
      name: "robots",
      content: "noindex, nofollow",
    });
  }

  if (page?.noindex && page?.noindex === 1) {
    seoTags.meta.push({
      vmid: "robots",
      name: "robots",
      content: "noindex",
    });
  }

  seoTags.meta.push({
    vmid: "twitter:card",
    property: "twitter:card",
    content: "summary_large_image",
  });

  return seoTags;
};
